import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['permission']

  connect () {
    this.validate()
  }

  validate () {
    const permissionSelected = this.permissionTargets.some(
      (checkbox) => checkbox.checked
    )

    this.permissionTargets[0].setCustomValidity(
      permissionSelected ? '' : 'Please select at least one API permission'
    )
  }
}
